import type { EventCategory } from './base';

export const UIEvents = {
  ISSUE_CREATED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string | undefined,
      issueId: '' as string,
      category: '' as string | null,
      route: '' as string,
      priority: '' as string | null,
      votes: 0 as number,
    },
  },
  COMMAND_PALETTE_OPENED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      trigger: 'keyboard' as 'keyboard' | 'button',
      role: '' as string,
    },
  },
  COMMAND_PALETTE_CLOSED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      method: 'escape' as 'escape' | 'click_outside' | 'navigation',
      searchTerm: '' as string | undefined,
      hadResults: false as boolean,
      durationMs: 0 as number,
    },
  },
  COMMAND_PALETTE_ACTION: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      actionType: 'navigation' as
        | 'navigation'
        | 'employee_search'
        | 'dish_search'
        | 'theme'
        | 'language'
        | 'logout',
      actionId: '' as string,
      searchTerm: '' as string | undefined,
      resultPosition: 0 as number | undefined,
      totalResults: 0 as number | undefined,
    },
  },
} as const;
